/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type GrantCreateScope = typeof GrantCreateScope[keyof typeof GrantCreateScope];


export const GrantCreateScope = {
  artifacts: 'artifacts',
  media: 'media',
  both: 'both',
} as const;
